export default {
  metadata: {
    version: '1.0.0',
    id: 'mega-menu-block-1.0.0',
    name: 'JDSMegaMenuBlock',
    platform: 'web'
  },
  hierarchy: {
    container: [
      'heading-jds-text',
      {
        'links-container': ['jds_mega_menu_item']
      }
    ]
  },
  base: {
    container: {
      'flex-direction': '{m_0}',
      'justify-content': '{m_1}',
      'align-items': '{m_2}',
      gap: '{m_3}'
    },
    'links-container': {
      'flex-direction': '{m_4}',
      'justify-content': '{m_5}',
      'align-items': '{m_6}'
    },
    'heading-jds-text': {
      'font-family': '{text_91}',
      color: '{text_20}',
      'font-size': '{text_90}',
      'line-height': '{text_92}',
      'letter-spacing': '{text_93}',
      'font-weight': '{text_94}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'padding-top': '{m_7}'
    }
  },
  api: {
    data: {
      'links-container': {
        value: {
          name: 'links',
          type: 'list',
          object: {
            title: 'string',
            href: 'string'
          }
        }
      },
      jds_mega_menu_item: {
        title: {
          type: 'string',
          name: 'links.title'
        },
        href: {
          type: 'string',
          name: 'links.href'
        }
      },
      'heading-jds-text': {
        value: {
          type: 'string',
          name: 'title'
        }
      }
    },
    a11y: {
      'links-container': {
        properties: {
          role: {
            value: 'list'
          }
        },
        name: 'links',
        repeating: {
          ariaLabel: 'linkAriaLabel',
          ariaDescribedby: {
            name: 'linkAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      jds_mega_menu_item: {
        properties: {
          ariaLabel: 'links.linkAriaLabel',
          ariaDescribedby: 'links.linkAriaDescribedby'
        }
      }
    }
  }
};
